import React, { useEffect, useState } from "react";
import { SerializedStyles } from "@emotion/react";
import { Attachment } from "../../../../types/common";
import VideoFallbackCard from "./VideoFallbackCard";

interface AttachmentMediaProps {
  attachment: Attachment;
  mediaCss?: SerializedStyles;
  mediaClassName?: string;
  controls?: boolean;
}

const VIDEO_FILE_PATTERN = /\.(mp4|webm|ogg|mov|m4v|avi)(\?|#|$)/i;

const isVideoAttachment = (attachment: Attachment) =>
  attachment.type?.startsWith("video/") ||
  VIDEO_FILE_PATTERN.test(attachment.url);

const AttachmentMedia: React.FC<AttachmentMediaProps> = ({
  attachment,
  mediaCss,
  mediaClassName,
  controls = true,
}) => {
  const isVideo = isVideoAttachment(attachment);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    setShowFallback(false);
  }, [attachment.id, attachment.type, attachment.url]);

  if (showFallback) {
    return <VideoFallbackCard />;
  }

  if (isVideo) {
    return (
      <video
        src={attachment.url}
        className={mediaClassName}
        css={mediaCss}
        controls={controls}
        playsInline
        muted
        preload="metadata"
        onError={() => setShowFallback(true)}
      />
    );
  }

  return (
    <img
      src={attachment.url}
      className={mediaClassName}
      css={mediaCss}
      onError={() => setShowFallback(true)}
    />
  );
};
export default AttachmentMedia;
